// import moment from 'moment'
import * as XLSX from 'xlsx'

export function exportToExcel (data: any[], nameReporter: string, filename = `${nameReporter}.xlsx`) {
  const newData = data.map(row => ({ ...row }))
  const worksheet = XLSX.utils.json_to_sheet(newData)
  // // recorrer todas las filas para asignar la column AG como fecha
  // Object.keys(worksheet).forEach((key) => {
  //   console.log('worksheet[key].v => ', worksheet[key].v)

  //   if (moment(worksheet[key].v, moment.ISO_8601, true).isValid()) {
  //     const fechaLocal = new Date(worksheet[key].v)
  //     const fechaSinOffset = new Date(fechaLocal.getTime() + fechaLocal.getTimezoneOffset() * 60000)
  //     // console.log('🚀 ~ Object.keys ~ key + i:', key)
  //     worksheet[key] = {
  //       t: 'd',
  //       v: fechaSinOffset
  //     }
  //   }
  // })

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Dates')
  XLSX.writeFile(workbook, filename)
}
